import { AccessHeadersHolder } from "@app/repositories/AccessHeadersHolder";
import { graphqlClientKoyeb } from "@app/repositories/clients";
import { graphql } from "@generated/client";
import { type ScoreValue } from "@generated/client/graphql";

const ScoreResponseMutation = graphql(`
    mutation ScoreResponse($traceId: ID!, $scoreValue: ScoreValue!) {
        scoreResponse(traceId: $traceId, scoreValue: $scoreValue) {
            status
        }
    }
`);

export class GraphQLAiRepository {
    scoreResponse = async (traceId: string, scoreValue: ScoreValue) => {
        return graphqlClientKoyeb.request(
            ScoreResponseMutation,
            { traceId, scoreValue },
            await AccessHeadersHolder.getHeaders(),
        );
    };
}
